module.exports = __webpack_public_path__ + "img/lr-cb4-2-r1.a9646799.gif";